import { render } from "./VideoWallPage.vue?vue&type=template&id=3caf2878&ts=true"
import script from "./VideoWallPage.vue?vue&type=script&lang=ts"
export * from "./VideoWallPage.vue?vue&type=script&lang=ts"

import "./VideoWallPage.vue?vue&type=style&index=0&id=3caf2878&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__